module.exports = __webpack_public_path__ + "static/media/boite-decouverte.67e8af66.png";